@if (isLoading) {
  <ui-loading-spinner></ui-loading-spinner>
}

<div class="deposit-slip-detail-page">
  <span class="deposit-slip-detail-title body-medium-emphasized">
    Dettaglio distinta di versamento
  </span>

  <div class="deposit-slip-detail-card">
    <div class="deposit-slip-summary deposit-slip-summary--mobile">
    <div class="deposit-slip-summary-row">
      <span class="body-large-emphasized">
        Distinta N° {{ dettaglio.numeroDistinta }}
      </span>
      <span
        class="body-medium deposit-status-badge"
        [ngClass]="statusBadgeClass(dettaglio.situazione)"
      >
        {{ dettaglio.situazione }}
      </span>
    </div>

    <div class="deposit-slip-summary-row">
      <span class="body-small">Data:</span>
      <span class="body-small">{{ dettaglio.dataCreazione | date:'dd/MM/yyyy' }}</span>
    </div>

    <div class="deposit-slip-summary-row">
      <span class="body-small">Totale contanti:</span>
      <span class="body-small">
        {{ dettaglio.riepilogo.totaleContanti | currency:'EUR':'symbol':'1.2-2' }}
      </span>
    </div>

    <div class="deposit-slip-summary-row">
      <span class="body-small">Totale assegni:</span>
      <span class="body-small">
        {{ dettaglio.riepilogo.totaleAssegni | currency:'EUR':'symbol':'1.2-2' }}
      </span>
    </div>

    <div class="deposit-slip-summary-row">
      <span class="body-large-emphasized">Totale assegni:</span>
      <span class="body-large-emphasized">
        {{ dettaglio.riepilogo.totaleDistinta | currency:'EUR':'symbol':'1.2-2' }}
      </span>
    </div>
    </div>

    <div class="deposit-slip-summary deposit-slip-summary--desktop">
    <div class="deposit-slip-desktop-heading">
      <div class="deposit-slip-desktop-title">
        <span class="body-large-emphasized">
          Riepilogo distinta di versamenti N° {{ dettaglio.numeroDistinta }}
        </span>
        <span
          class="body-medium deposit-status-badge"
          [ngClass]="statusBadgeClass(dettaglio.situazione)"
        >
          {{ dettaglio.situazione }}
        </span>
      </div>

      <span class="body-large-emphasized">
        Totale distinta:
        {{ dettaglio.riepilogo.totaleDistinta | currency:'EUR':'symbol':'1.2-2' }}
      </span>
    </div>

    <div class="deposit-slip-desktop-values">
      <div class="deposit-slip-desktop-value">
        <span class="body-small">Data creazione</span>
        <span class="body-medium-emphasized">
          {{ dettaglio.dataCreazione | date:'dd/MM/yyyy' }}
        </span>
      </div>

      <div class="deposit-slip-desktop-value">
        <span class="body-small">Totale contanti</span>
        <span class="body-medium-emphasized">
          {{ dettaglio.riepilogo.totaleContanti | currency:'EUR':'symbol':'1.2-2' }}
        </span>
      </div>

      <div class="deposit-slip-desktop-value">
        <span class="body-small">Totale assegni</span>
        <span class="body-medium-emphasized">
          {{ dettaglio.riepilogo.totaleAssegni | currency:'EUR':'symbol':'1.2-2' }}
        </span>
      </div>
    </div>
    </div>
  </div>

  <mat-tab-group
    animationDuration="0ms"
    class="deposit-slip-tabs"
    mat-align-tabs="start"
    (selectedIndexChange)="selectedTabIndex = $event"
  >
    <mat-tab label="Verifica contanti">
      <div class="deposit-slip-tab-content deposit-slip-general-mobile">
        @if (dettaglio.versamentiContanti.length > 0) {
          <div class="deposit-slip-general-section">
          <span class="title-medium-emphasized">
            Elenco versamenti in contante
          </span>

          <div class="deposit-slip-general-card-list">
            @for (versamento of dettaglio.versamentiContanti; track versamento.idIncasso) {
              <div
                class="deposit-slip-general-card deposit-slip-cash-card"
                role="button"
                tabindex="0"
                [attr.aria-label]="'Apri distinta incasso ' + versamento.idIncasso"
                (click)="apriDettaglioContanti(versamento.idIncasso)"
                (keydown.enter)="apriDettaglioContanti(versamento.idIncasso)"
                (keydown.space)="$event.preventDefault(); apriDettaglioContanti(versamento.idIncasso)"
              >
              <div class="deposit-slip-general-card-data">
                <div class="deposit-slip-general-card-row body-medium-emphasized">
                  <span>Incasso:</span>
                  <span>{{ versamento.idIncasso }}</span>
                </div>
                <div class="deposit-slip-general-card-row body-medium">
                  <span>Data incasso:</span>
                  <span>{{ versamento.dataIncasso | date:'dd/MM/yyyy' }}</span>
                </div>
                <div class="deposit-slip-general-card-row body-medium">
                  <span>Totale monete:</span>
                  <span class="body-medium-emphasized">
                    {{ versamento.totaleMonete | currency:'EUR':'symbol':'1.2-2' }}
                  </span>
                </div>
                <div class="deposit-slip-general-card-row body-medium">
                  <span>Totale banconote:</span>
                  <span class="body-medium-emphasized">
                    {{ versamento.totaleBanconote | currency:'EUR':'symbol':'1.2-2' }}
                  </span>
                </div>
                <div class="deposit-slip-general-card-row body-medium-emphasized">
                  <span>Totale:</span>
                  <span>
                    {{ versamento.importoTotale | currency:'EUR':'symbol':'1.2-2' }}
                  </span>
                </div>
              </div>

              <div class="deposit-slip-general-card-action" aria-hidden="true">
                <i class="fa-regular fa-chevron-right"></i>
              </div>
              </div>
            }
          </div>
          </div>
        } @else {
          <span class="deposit-slip-empty-state body-medium">Nessun contante da verificare</span>
        }
      </div>

      <div class="deposit-slip-tab-content deposit-slip-general-desktop">
        @if (dettaglio.versamentiContanti.length > 0) {
          <div class="deposit-slip-general-desktop-section">
            <span class="title-medium-emphasized">Elenco versamenti in contante</span>

            <ui-table-view
              [columnsInfo]="versamentiContantiColumns"
              [data]="versamentiContantiTable"
            />
          </div>
        } @else {
          <span class="deposit-slip-empty-state body-medium">Nessun contante da verificare</span>
        }
      </div>

    </mat-tab>

    <mat-tab label="Verifica assegni">
      <div class="deposit-slip-tab-content deposit-slip-general-mobile">
        @if (dettaglio.assegni.length > 0) {
          <div class="deposit-slip-general-section">
          <span class="title-medium-emphasized">Elenco assegni da verificare</span>

          <div class="deposit-slip-general-card-list">
            @for (assegno of dettaglio.assegni; track assegno.id) {
              <div class="deposit-slip-general-card deposit-slip-check-card">
                <div class="deposit-slip-check-card-selection">
                  @if (assegno.verificato) {
                    <i
                      class="fa-regular fa-check deposit-slip-check-verified-icon"
                      [attr.aria-label]="'Assegno ' + assegno.numeroAssegno + ' verificato'"
                    ></i>
                  } @else {
                    <mat-checkbox
                      [checked]="isAssegnoSelezionato(assegno.id)"
                      [attr.aria-label]="'Seleziona assegno ' + assegno.numeroAssegno"
                      (change)="selezionaAssegno(assegno.id, $event.checked)"
                    />
                  }
                </div>

                <div class="deposit-slip-general-card-data">
                  <div class="deposit-slip-check-card-row body-medium-emphasized">
                    <span>Assegno N° {{ assegno.numeroAssegno }}</span>
                    <span>
                      {{ assegno.importoTotale | currency:'EUR':'symbol':'1.2-2' }}
                    </span>
                  </div>
                  <div class="deposit-slip-check-card-row body-medium">
                    <span>Data incasso:</span>
                    <span>{{ assegno.dataIncasso | date:'dd/MM/yyyy' }}</span>
                  </div>
                  <div class="deposit-slip-check-card-row body-medium">
                    <span>Banca:</span>
                    <span class="body-medium-emphasized">{{ assegno.banca }}</span>
                  </div>
                  <div class="deposit-slip-check-card-row body-medium">
                    <span>ABI:</span>
                    <span class="body-medium-emphasized">{{ assegno.abi }}</span>
                  </div>
                  <div class="deposit-slip-check-card-row body-medium">
                    <span>CAB:</span>
                    <span class="body-medium-emphasized">{{ assegno.cab }}</span>
                  </div>
                </div>
              </div>
            }
          </div>
          </div>
        } @else {
          <span class="deposit-slip-empty-state body-medium">Nessun assegno da verificare</span>
        }
      </div>

      <div class="deposit-slip-tab-content deposit-slip-general-desktop">
        @if (dettaglio.assegni.length > 0) {
          <div class="deposit-slip-general-desktop-section">
          <span class="title-medium-emphasized">Elenco assegni da verificare</span>

          <ui-table-view
            [columnsInfo]="assegniVerificaColumns"
            [data]="assegniTable"
          />
          </div>
        } @else {
          <span class="deposit-slip-empty-state body-medium">Nessun assegno da verificare</span>
        }
      </div>

    </mat-tab>

    <mat-tab label="Versamento">
      <div class="deposit-slip-tab-content deposit-slip-payment-content">
        <span class="deposit-slip-payment-title title-medium-emphasized">
          Dettagli versamento
        </span>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Banca</mat-label>
          <mat-select [(ngModel)]="codBanca" [disabled]="versamentoReadOnly">
            @for (banca of banche; track banca.value) {
              <mat-option [value]="banca.value">{{ banca.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Numero operazione</mat-label>
          <input
            matInput
            placeholder="[numero ricevuta ATM]"
            [(ngModel)]="numeroOperazione"
            [disabled]="versamentoReadOnly"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Data</mat-label>
          <input
            matInput
            [matDatepicker]="depositDatePicker"
            [(ngModel)]="dataVersamento"
            [disabled]="versamentoReadOnly"
          />
          <mat-datepicker-toggle matIconSuffix [for]="depositDatePicker" [disabled]="versamentoReadOnly" />
          <mat-datepicker #depositDatePicker />
        </mat-form-field>

        <span class="deposit-slip-payment-heading label-medium-emphasized">
          Carica la ricevuta di versamento
        </span>

        <div
          class="deposit-slip-upload-area"
          [class.deposit-slip-upload-area--disabled]="versamentoReadOnly"
          role="button"
          [attr.tabindex]="versamentoReadOnly ? -1 : 0"
          [attr.aria-disabled]="versamentoReadOnly"
          aria-label="Carica una ricevuta PDF, JPG o PNG"
          (click)="apriSelettoreFile(receiptFileInput)"
          (keydown.enter)="apriSelettoreFile(receiptFileInput)"
          (keydown.space)="$event.preventDefault(); apriSelettoreFile(receiptFileInput)"
          (dragover)="trascinaRicevuta($event)"
          (drop)="rilasciaRicevuta($event)"
        >
          <div class="deposit-slip-upload-icon" aria-hidden="true">
            <i class="fa-regular fa-arrow-up-from-bracket"></i>
          </div>

          <span class="body-medium">Carica la ricevuta</span>

          <span class="deposit-slip-upload-hint body-small">
            PDF, JPG o PNG (max 10MB)
          </span>

          <input
            #receiptFileInput
            class="deposit-slip-upload-input"
            type="file"
            accept="application/pdf,image/jpeg,image/png,.pdf,.jpg,.jpeg,.png"
            [disabled]="versamentoReadOnly"
            (change)="selezionaRicevuta($event)"
          />
        </div>

      </div>
    </mat-tab>
  </mat-tab-group>

  <div
    class="deposit-slip-detail-actions"
    [class.deposit-slip-detail-actions--payment]="selectedTabIndex === 2"
  >
    @switch (selectedTabIndex) {
      @case (0) {
        @if (haVersamentiContanti) {
          <button
            matButton="filled"
            type="button"
            [disabled]="!inLavorazione || isSaving || !puoVerificare"
            (click)="verificaDistinta()"
          >
            Conferma
          </button>
        }
      }
      @case (1) {
        @if (haVersamentiAssegni) {
          @if (tuttiAssegniVerificati) {
            <button
              matButton="filled"
              type="button"
              [disabled]="!inLavorazione || isSaving || !puoVerificare"
              (click)="verificaDistinta()"
            >
              Conferma
            </button>
          } @else {
            <button
              matButton="filled"
              type="button"
              class="deposit-slip-confirm-checks-button"
              [disabled]="!inLavorazione || isSaving || !puoVerificare || !haAssegniSelezionati"
              (click)="verificaAssegni()"
            >
              Conferma Assegni
            </button>
          }
        } @else if (haVersamentiContanti) {
          <button
            matButton="filled"
            type="button"
            [disabled]="!inLavorazione || isSaving || !puoVerificare"
            (click)="verificaDistinta()"
          >
            Conferma
          </button>
        }
      }
      @case (2) {
        <button
          matButton="filled"
          type="button"
          [disabled]="!puoChiudere || isSaving"
          (click)="caricaEChiudi()"
        >
          Carica e Chiudi versamento
        </button>
      }
    }

    <button matButton="outlined" type="button" (click)="scaricaPdf()">
      Scarica PDF
    </button>

    @if (inLavorazione) {
      <button
        matButton="outlined"
        type="button"
        class="deposit-slip-delete-button"
        *uiCan="CAPS.distintaElimina"
        [disabled]="isSaving"
        (click)="elimina()"
      >
        Elimina distinta
      </button>
    }
  </div>
</div>
